import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Modal from '../../UniformComponents/Modal'
import CheckboxGroup from '../form/CheckboxGroup'

@observer
class ComparisonModal extends Component {
    changeYears = ({ value }) => {
        const { DataExplorerStore } = this.props
        const { changeYears } = DataExplorerStore

        changeYears(value.map((v) => Number(v)))
    }

    changePeriods = ({ value }) => {
        const { DataExplorerStore } = this.props
        const { changeIncludedPeriods } = DataExplorerStore

        changeIncludedPeriods(value.map((v) => Number(v)))
    }

    changeBenchmarks = ({ value }) => {
        const { DataExplorerStore } = this.props
        const { changeBenchmarks } = DataExplorerStore

        changeBenchmarks(value)
    }

    render() {
        const { DataExplorerStore } = this.props
        const {
            yearOptions, years, benchmarks, benchmarkOptions,
            periodOptions, periods, showComparisonSelector, toggleComparisonSelector,
        } = DataExplorerStore
        return (
            <Modal show={showComparisonSelector} onClose={toggleComparisonSelector}>
                <div className="comparisonSelector">
                    <div className="benchmarks">
                        <CheckboxGroup
                            name="benchmarks"
                            label="Benchmarks"
                            options={benchmarkOptions}
                            defaultChecked={benchmarks.slice()}
                            onBlur={this.changeBenchmarks}
                            returnValueUnchanged
                        />
                    </div>
                    <div className="periods">
                        <CheckboxGroup
                            name="periods"
                            label="Periods"
                            options={periodOptions}
                            defaultChecked={periods.slice()}
                            onBlur={this.changePeriods}
                            returnValueUnchanged
                        />
                    </div>
                    <div className="years">
                        <CheckboxGroup
                            name="years"
                            label="Years"
                            options={yearOptions.slice().sort((a, b) => b.value - a.value)}
                            defaultChecked={years.slice().sort((a, b) => b.value - a.value)}
                            onBlur={this.changeYears}
                            returnValueUnchanged
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ComparisonModal
